var map = {
	"./1.jpg": "b805",
	"./2.jpg": "302a",
	"./3.jpg": "9913",
	"./5.jpg": "115a",
	"./6.jpg": "4d45",
	"./7.jpg": "0288",
	"./8.jpg": "fa4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d97";